export default __webpack_public_path__ + "static/media/DDD-centre.1c5cd87d.jpg";